function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M0,0H28V28H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M26.833,12.812,21,12.8A1.187,1.187,0,0,0,19.833,14V24.8A1.187,1.187,0,0,0,21,26h5.833A1.187,1.187,0,0,0,28,24.8V14A1.177,1.177,0,0,0,26.833,12.812Zm0,10.788H21V15.2h5.833ZM23.333,2h-21A2.374,2.374,0,0,0,0,4.4V18.8a2.374,2.374,0,0,0,2.333,2.4H10.5v2.4H9.333a1.2,1.2,0,0,0,0,2.4h7a1.2,1.2,0,0,0,0-2.4H15.167V21.2h1.167a1.2,1.2,0,0,0,0-2.4H3.5a1.187,1.187,0,0,1-1.167-1.2V5.6A1.187,1.187,0,0,1,3.5,4.4H22.167a1.187,1.187,0,0,1,1.167,1.2V9.2a1.167,1.167,0,1,0,2.333,0V4.4A2.374,2.374,0,0,0,23.333,2Zm-9.368,8.4L12.833,6.8,11.7,10.4H8.167l2.882,2.112L9.952,16l2.882-2.16L15.715,16l-1.1-3.492L17.5,10.4Z",
  transform: "translate(0 0)",
  fill: "#797979"
});

var SvgProject = function SvgProject(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "important_devices-black-18dp",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/project.b337eb47.svg";
export { ForwardRef as ReactComponent };